import { CALL_API } from 'redux-api-middleware'
import { get, post } from 'utils/network'

export const fetchMe = () => {
  const request = get('/me')
  request.types = ['USERS_REQ', 'USERS_ME_SUCC', 'USERS_ME_FAIL']
  return { [CALL_API]: request }
}

export const changePassword = (payload) => {
  const request = post('/change-password', payload)
  request.types = [
    'AUTH_REQ',
    {
      type: 'NOTIF_SUCC',
      meta: { msg: 'Password changed successfully.' },
    },
    'NOTIF_FAIL',
  ]

  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Account/actions.js